export default __webpack_public_path__ + "static/media/chat.c731308c.svg";